import { GitHub, Twitter, Linkedin, Instagram } from 'react-feather'
import './Footer.css'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="company-name">EVOAXY</h3>
            <p className="company-description">
              Transforming ideas into digital reality. We create innovative solutions 
              for businesses worldwide.
            </p>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/ignix-solutions/" className="social-link">
                <GitHub size={20} />
              </a>
              <a href="#" className="social-link">
                <Twitter size={20} />
              </a>
              <a href="https://www.linkedin.com/company/ignix-solutions/" className="social-link">
                <Linkedin size={20} />
              </a>
              <a href="#" className="social-link">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="/services/web-development">Web Development</a></li>
              <li><a href="/services/mobile-development">Mobile Apps</a></li>
              <li><a href="/services/cloud-solutions">Cloud Solutions</a></li>
              <li><a href="/services/ui-ux-design">UI/UX Design</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#team">Our Team</a></li>
      
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/terms-of-service">Terms of Service</a></li>
              <li><a href="/cookie-policy">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Evoaxy Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

